import { useAppConfiguration } from '@mews-commander/data-access';
import { PlatformEnvironment } from '@mews/enums';

export const useTenantUrl = () => {
    const { environment } = useAppConfiguration();
    const isDemoEnv = environment === PlatformEnvironment.Demo;
    const isDevelopmentEnv = environment === PlatformEnvironment.Development;

    if (isDemoEnv) {
        return 'https://user-provisioning.mews-demo.com/scim/v2';
    }

    if (isDevelopmentEnv) {
        return 'https://user-provisioning.mews-develop.com/scim/v2';
    }

    return 'https://user-provisioning.services.mews.com/scim/v2';
};
